import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { images } from '../data/offer';
export function FinalCtaSection() {
  return <section className="w-full bg-navy-900 px-5 py-16 text-white sm:py-20" data-id="element-115" data-mp="3lw9i6yezd253">
      <div className="mx-auto max-w-3xl text-center" data-id="element-116" data-mp="3quaxd89achba">
        <h2 className="font-display text-[40px] font-black uppercase leading-[0.95] sm:text-6xl" data-id="element-117" data-mp="3vsw13hnqxj4h">
          Ready to stop guessing and start following a <span className="text-gold-400" data-id="element-118" data-mp="2y6ow46nj5orl">structured process?</span>
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-[17px] leading-relaxed text-slate-300" data-id="element-119" data-mp="334qgcuwozu4n">
          <p data-id="element-120" data-mp="381guhcoxsfnf">
            When an unfamiliar TCM arrives at your workshop, you shouldn't have to start by searching through dozens of
            unrelated resources.
          </p>
          <p data-id="element-121" data-mp="2fdb9qpxvuqnl">
            Get the complete six-volume system, all five bonuses, and the practical reference materials for one
            affordable payment.
          </p>
        </div>
        <div className="-mx-5 mt-6 sm:mx-auto sm:max-w-xl" data-id="element-122" data-mp="2dcjn1pf6oz5g">
          <img src={images.hero} alt="Complete TCM Diagnostic Blueprint™ package" className="w-full" loading="lazy" data-id="element-123" data-mp="2dduo3hh8vssv" />
        </div>
        <p className="mt-4 font-display text-2xl font-bold uppercase text-slate-300" data-id="element-124" data-mp="23low47qztbdo">
          Only <span className="text-[64px] font-black leading-none text-cta-400" data-id="element-125" data-mp="1yndl3toyoutv">$27</span> USD
        </p>
        <CtaButton label="Get TCM Diagnostic Blueprint™" tone="dark" className="mt-6" data-id="element-126" data-mp="1ul8tf0i2q89v" />
        <Countdown tone="dark" data-id="element-127" data-mp="1pmfk7k9tl3fi" />
      </div>
    </section>;
}